import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";
import autoBind from "react-autobind";
import themes from "../../constants/themes";
import _ from "lodash";


class EmbeddedTimer extends PureComponent {
	constructor(props) {
		super(props);
		autoBind(this);
	}

	render() {

		const { timer } = this.props;
		const theme = global.activityTheme ? global.activityTheme : themes[(this.props.nightMode) ? "nightMode" : "default"];

		// console.log("Render embedded timer", timer);
		//let component = null;
		let chosenProgressbarProp = "progressBarLessThan50PercentDone";
		if (timer && (timer.viewType === "top-right" || timer.viewType === "top-left")) {
			// console.log("Timer & PrimaryTimer");
			const { countdownSecondsRemaining, label1, label2, type, totalSeconds } = timer;


			let remaining = 0;

			let progressBarStyles = {};

			if (type === "countup") {
				progressBarStyles.left = 0;
				if (totalSeconds !== 0 && countdownSecondsRemaining !== 0) {
					remaining = ((countdownSecondsRemaining / totalSeconds) * 100);
				}

				// console.log("Info", remaining, countdownSecondsRemaining, totalSeconds);

				if (remaining >= 75) {
					chosenProgressbarProp = "progressBarOver75PercentDone";
				} else if (remaining >= 50) {
					chosenProgressbarProp = "progressBar50To75PercentDone";
				}
			} else {
				progressBarStyles.right = 0;
				if (totalSeconds !== 0 && countdownSecondsRemaining !== 0) {
					remaining = (countdownSecondsRemaining / totalSeconds) * 100;
				}

				// console.log("Info", remaining, countdownSecondsRemaining, totalSeconds);


				if (remaining <= 25) {
					chosenProgressbarProp = "progressBarOver75PercentDone";
				} else if (remaining <= 50) {
					chosenProgressbarProp = "progressBar50To75PercentDone";
				}
			}


			const wrapperStyle = _.assign({}, { display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", paddingLeft: 5, position: "relative", height: "100%" }, theme.appBar.timer.wrapper);
			// const containerDigitsStyle = _.assign({}, { flex: 1, display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "100%" }, theme.appBar.timer.containerDigits);
			const timerDigitsStyle = _.assign({}, { fontSize: 48,lineHeight: "50px", color: "white", fontWeight: "bold", textShadowColor: "black", textShadowRadius: 2, textShadowOffset: { width: 1, height: 1 }, fontFamily: "Courier" }, theme.appBar.timer.timerDigits);
			const containerLabelsStyle = _.assign({}, { display: "flex", flexDirection: "column", backgroundColor: "#444444", height: "100%", flex: 1, justifyContent: "center", paddingLeft: 5 }, theme.appBar.timer.containerLabels);
			const label1Style = _.assign({}, { color: "white", fontSize: 14 }, theme.appBar.timer.label1Text);
			const label2Style = _.assign({}, { color: "white", fontSize: 14 }, theme.appBar.timer.label2Text);
			const progressBarContainerStyle = _.assign({}, { position: "absolute", left: 0, bottom: 0, height: 3, backgroundColor: "#444444", zIndex: 2, right: 0 }, theme.appBar.timer.progressBarContainer);
			const progressBarStyles2 = _.assign({}, { position: "absolute", bottom: 0, height: 3, width: `${remaining}%`, zIndex: 3, right: 0 }, progressBarStyles, theme.appBar.timer.progressBar, theme.appBar.timer[chosenProgressbarProp], _.pick(theme.appBar.timer.progressBarContainer, ["height"]));

			console.log("log: " + label1 || label2);

			return (
				<div style={wrapperStyle}>
					<div className="embedded-timer-digits-container" style={{ flex: 1, display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "100%" }}>
						<div className="embedded-timer-digits" style={timerDigitsStyle}>{timer.countdownTimeEssential}</div>
					</div>
					{((typeof label1 !== "undefined" && label1 !== "") || (typeof label2 !== "undefined" && label2 !== ""))  &&
						<div className="embedded-timer-labels-container" style={containerLabelsStyle}>
							<div style={label1Style}>{label1}</div>
							<div style={label2Style}>{label2}</div>
						</div>
					}
					<div style={progressBarContainerStyle}></div>
					<div style={progressBarStyles2}></div>
				</div>
			);
		}

		return null;
	}
}

// const styles = {
// 	percentage: { fontSize: 10, color: "white", fontWeight: "bold", textShadowColor: "black", textShadowRadius: 2, textShadowOffset: { width: 1, height: 1 } },
// 	percentageLarge: { fontSize: 48, color: "white", fontWeight: "bold", textShadowColor: "black", textShadowRadius: 2, textShadowOffset: { width: 1, height: 1 }, fontFamily: "Courier" }
// };

export default branch((props) => {
	return {
		timer: ["timers", String(Number(props.timerKey))],
		nightMode: ["nightMode"]
	};
}, EmbeddedTimer);